/** Maps D365 DataAreaId to ISO 3166-1 alpha-2 country code */
const dataAreaToCountry: Record<string, string> = {
    NSAU: "AU",
    NSBE: "BE",
    NSCA: "CA",
    NSDE: "DE",
    NSDK: "DK",
    NSES: "ES",
    NSFR: "FR",
    NSG1: "US",
    NSGB: "GB",
    NSHK: "CN",
    NSHR: "HR",
    NSIT: "IT",
    NSNL: "NL",
    NSNZ: "NZ",
    NSSA: "ZA",
    NSSE: "SE",
    NSSL: "LK",
};

const countryCodeToName: Record<string, string> = {
    AU: "Australia",
    BE: "Belgium",
    CA: "Canada",
    DE: "Germany",
    DK: "Denmark",
    ES: "Spain",
    FR: "France",
    US: "United States",
    GB: "United Kingdom",
    CN: "China",
    HR: "Croatia",
    IT: "Italy",
    NL: "Netherlands",
    NZ: "New Zealand",
    ZA: "South Africa",
    SE: "Sweden",
    LK: "Sri Lanka",
};

/** Returns the ISO 3166-1 alpha-2 country code for a DataAreaId, or null if unknown */
export function getCountryCode(dataAreaId: string | undefined | null): string | null {
    if (!dataAreaId) {
        return null;
    }
    return dataAreaToCountry[dataAreaId.toUpperCase()] ?? null;
}

/** Returns a human-readable country name for an ISO alpha-2 code */
export function getCountryName(code: string | null): string | null {
    if (!code) {
        return null;
    }
    return countryCodeToName[code.toUpperCase()] ?? code;
}
